// What the measure panel shows, built by measureView() from the tool's state so the
// panel itself stays presentational.

export type MeasurePanelStep = 'start' | 'pickStart' | 'placing' | 'range' | 'placed';
export type MeasureLockMode = 'Free' | 'Distance' | 'Bearing';

export interface MeasureStatCell {
  label: string;
  value: string;
  /** The bearing is the one figure in yellow. */
  accent: boolean;
}

export interface MeasureLockItem {
  mode: MeasureLockMode;
  title: string;
  detail: string;
  /** Desktop only: the modifier that does the same for one drag. */
  kbd: string;
  on: boolean;
}

export interface MeasureSegment<T extends string> {
  value: T;
  label: string;
  on: boolean;
}

export interface MeasureView {
  narrow: boolean;
  step: MeasurePanelStep;
  title: string;
  stats: MeasureStatCell[];
  isPreview: boolean;
  myLocation: { detail: string; disabled: boolean };
  pickDetail: string;
  showRightClickTip: boolean;
  from: { name: string; grid: string; isMyLocation: boolean } | null;
  range: {
    intro: string;
    distanceLabel: string;
    bearingLabel: string;
    note: string;
  };
  placed: {
    gridText: string;
    gridTitle: string;
    copyLabel: string;
    copied: boolean;
    timeBack: string;
    profile: {
      line: string;
      area: string;
      label: string;
      status: 'ready' | 'loading' | 'unavailable';
      hover: { x: number; text: string; leftPercent: number; shift: string } | null;
    };
  } | null;
  pills: {
    show: boolean;
    snap: { show: boolean; on: boolean };
    createHike: boolean;
    lock: { show: boolean; title: string; icon: string; locked: boolean; menuOpen: boolean; items: MeasureLockItem[] };
  };
  settings: {
    open: boolean;
    north: MeasureSegment<'True' | 'Magnetic' | 'Grid'>[];
    northCaption: string;
    units: MeasureSegment<'Degrees' | 'Mils'>[];
    gridFormat: string;
    gridFormats: { value: string; label: string }[];
    tolerance: string;
    showKeyboard: boolean;
  };
  toast: string;
}

/** The profile strip is drawn in a fixed viewBox and stretched to the panel's width. */
export const PROFILE_VIEWBOX = { width: 328, height: 44 };
